import React from "react";

export const CYR_IMAGE =
  "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1739114710/Duo%20Serendipia/003_1540-NEF_DxO_DeepPRIME_zllfw1.jpg";

export const HAND_TO_HAND_IMAGE =
  "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1785345714/Duo%20Serendipia/_MG_5769-CR2_DxO_DeepPRIME_o1cfvc.jpg";

export const selectedExperience = [
  {
    title: "Romantic Corporate",
    location: "Lanzarote, Spain",
    period: "2026–Present",
    description:
      "Resident circus performers presenting Cyr wheel, duo acrobatics and movement acts.",
  },
  {
    title: "Romantic Corporate",
    location: "Mallorca, Spain",
    period: "2025",
    description:
      "Performers in a resident multidisciplinary circus production.",
  },
  {
    title: "Innovacirco / CINO Goldstar",
    location: "Antalya, Turkey",
    period: "2024",
    description:
      "Six-month contract performing Cyr wheel and duo acrobatics in five-star hotels.",
  },
  {
    title: "Festival Payasadas",
    location: "Rosario, Argentina",
    period: "2023",
    description:
      "Selected performers and workshop instructors at an international circus festival.",
  },
  {
    title: "MICA",
    location: "Argentina",
    period: "2023",
    description: "Selected for the Argentine Cultural Industries Market.",
  },
  {
    title: "Circo del Ánima by Flavio Mendoza",
    location: "Argentina",
    period: "2022",
    description:
      "Solo and duo Cyr wheel performances in a large-scale circus production.",
  },
];

export const additionalSkillsLeft: React.ReactNode[] = [
  <>
    Solo Cyr wheel — <strong>Diana</strong>
  </>,
  <>
    Solo Cyr wheel — <strong>José</strong>
  </>,
  <>
    Handstands — <strong>Diana</strong>
  </>,
  <>
    Partner acrobatics — <strong>Diana & José</strong>
  </>,
];

export const additionalSkillsRight: React.ReactNode[] = [
  <>
    Acro-dance — <strong>Diana</strong>
  </>,
  <>
    Acrobatic tango — <strong>Diana & José</strong>
  </>,
  <>
    Cube manipulation — <strong>José</strong>
  </>,
];
